import {Component, OnInit} from '@angular/core';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ModalDismissReasons, NgbHighlight, NgbModal, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule, DatePipe} from '@angular/common'
import {ToastrService} from 'ngx-toastr';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {FormsModule} from '@angular/forms';
import {UtilsInjectable} from '@app/shared';

@Component({
  selector: 'app-purchase-return',
  templateUrl: './purchase-return.component.html',
  styleUrls: ['./purchase-return.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    SelectDropDownModule,
    NgbHighlight,
    NgbTypeahead
  ],
  providers: [DatePipe]
})
export class PurchaseReturnComponent implements OnInit {
  index = 0;
  user_rights: any;
  user_data: any;
  public now = new Date();
  public purchase_details: any = [""];
  date: any;
  unit: any;
  purchase_data: any = [];
  total_amount = 0;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  status: any;
  closeResult = '';

  public purchase_retrun: any =
    {
      vendor_id: '',
      purchase_details_id: [""],
      invoice_date: '',
      customer_trn: '',
      return_reason: [""],
      sor_no: "",
      customer_ref: "",
      sales_person: "",
      discount: "",
      return_date: new Date(),
      reference_no: "",
      purchase_id: 0,
      puchase_return_id: 0,
      medicine_data: [],
      medicine_id_arr: [""],
      quantity_arr: [""],
      ava_quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      paking_arr: [""],
      amount_arr: [""],
      return_qty_arr: [""],
      unitprice_arr: [""],
      return_amount_arr: [""],
      purchased_qty: [""],
      freebie_qty: [""],
      actual_arr: [""],
      gross_arr: [""],
      vat_arr: [""],
      user_id: '',
      invoice_no: [""]
    }
  vendor: any;
  vendor_options: any;
  vendor_data: any;
  invoice: any = [""];
  medicine: any;
  searching = false;
  searchFailed = false;
  invoice_data: any;

  medicine_data: any;
  purchased: any;
  purchase_return_id: any = "";
  item: any;

  constructor(private loaderService: LoaderService,
              private modalService: NgbModal,
              public rest2: ConsultingService,
              protected toast: ToastrService,
              private route: ActivatedRoute,
              protected utils: UtilsInjectable) {
  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");

    this.route.params.subscribe(params => {
      this.purchase_return_id = Number.parseInt(params['purchase_return_id']);
      this.getDropdowns();
      const id = +(this.route.snapshot.paramMap.get('id') || "");
      if (id != null && id != 0) {
        this.purchase_return_id = '';
        this.getPurchaseDetails(id);
      } else {
        this.getDropdowns();
      }
    });
    this.getDropdowns();
  }

  public getPurchaseDetails(id: any) {
    const postData = {
      purchase_return_id: id
    };
    this.loaderService.display(true);
    this.loaderService.display(true);
    this.rest2.getReturnPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchased = result['data'];
        this.purchase_retrun.vendor_id = this.purchased.VENDOR_ID;
        this.purchase_retrun.return_date = this.purchased.RETURN_DATE;
        this.purchase_retrun.reference_no = this.purchased.REFERENCE_NUMBER;
        this.purchase_retrun.return_reason = this.purchased.RETURN_REASON;

        let i = 0;
        this.purchase_details = ['0'];
        const num_rows = [];
        for (const val of result['data'].PURCHASE_RETURN) {
          const temp = {
            'MEDICINE_ID': val.MEDICINE_ID,
            'TRADE_NAME': val.TRADE_NAME,
          };
          num_rows[i] = i;
          num_rows.push(i);
          this.purchase_retrun.medicine_id_arr[i] = temp;
          this.purchase_retrun.quantity_arr[i] = val.QUANTITY;
          this.purchase_retrun.return_qty_arr[i] = val.RETURN_QUANTITY;
          this.purchase_retrun.return_amount_arr[i] = val.RETURN_AMOUNT;
          this.purchase_retrun.amount_arr[i] = val.AMOUNT;
          this.purchase_retrun.uom_arr_name[i] = val.UNIT_DESC;
          this.purchase_retrun.unitprice_arr[i] = val.UNIT_PRICE;
          this.purchase_retrun.retailprice_arr[i] = val.MRP;
          this.purchase_retrun.dis_arr[i] = val.DISCOUNT;
          i = i + 1;
        }
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.purchase_retrun = {
          vendor_id: '',
          puchase_id: '',
          invoice_date: '',
          customer_trn: '',
          return_reason: [""],
          sor_no: "",
          customer_ref: "",
          sales_person: "",
          return_date: new Date(),
          reference_no: "",
          purchase_id: 0,
          puchase_return_id: 0,
          medicine_data: [],
          medicine_id_arr: [""],
          purchase_details_id: [""],
          quantity_arr: [""],
          ava_quantity_arr: [""],
          uom_arr: [""],
          uom_arr_name: [""],
          paking_arr: [""],
          amount_arr: [""],
          return_qty_arr: [""],
          unitprice_arr: [""],
          return_amount_arr: [""],
          purchased_qty: [""],
          freebie_qty: [""],
          vat_arr: [""],
          actual_arr: [""],
          gross_arr: [""],
          user_id: '',
          invoice_no: [""]

        }
      }
    });
  }

  public listInvoice(i: any) {
    const opdata = {
      vendor_id: this.purchase_retrun.vendor_id,
      medicine_id: this.purchase_retrun.medicine_id_arr[i],
    };
    this.rest2.listInvoiceNo(opdata).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.invoice[i] = result['data'];
        if (this.invoice[i].length == 1) {
          this.purchase_retrun.invoice_no[i] = this.invoice[i][0].INVOICE_NUMBER
          this.listProductDetails(i);
        }
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public listProductDetails(i: any) {
    const postData = {
      vendor_id: this.purchase_retrun.vendor_id,
      medicine_id: this.purchase_retrun.medicine_id_arr[i],
      invoice_no: this.purchase_retrun.invoice_no[i]

    };

    this.rest2.listProductDetails(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.item = result['data'];
        for (const item of this.item) {
          this.purchase_retrun.uom_arr_name[i] = item.UNIT_DESC;
          this.purchase_retrun.purchase_details_id[i] = item.PURCHASE_DETAILS_ID;
          this.purchase_retrun.quantity_arr[i] = item.QUANTITY;
          if (item.AVAILABLE_STOCK_QUANTITY > 0) {
            this.purchase_retrun.ava_quantity_arr[i] = item.AVAILABLE_STOCK_QUANTITY;
          } else {
            this.purchase_retrun.ava_quantity_arr[i] = 0;
          }

          this.purchase_retrun.uom_arr[i] = item.UNIT;
          this.purchase_retrun.uom_arr_name[i] = item.UNIT_DESC;
          this.purchase_retrun.paking_arr[i] = item.DESCRIPTION;
          this.purchase_retrun.amount_arr[i] = item.AMOUNT;
          this.purchase_retrun.unitprice_arr[i] = item.UNIT_PRICE;
          this.purchase_retrun.invoice_no[i] = item.INVOICE_NUMBER;
          this.purchase_retrun.purchased_qty[i] = item.PURCHASED_QUANTITY;
          this.purchase_retrun.freebie_qty[i] = item.FREEBIE_QUANTITY;
          this.purchase_retrun.vat_arr[i] = item.VAT_AMOUNT;
          this.purchase_retrun.gross_arr[i] = item.GROSS_AMOUNT;
          this.purchase_retrun.actual_arr[i] = item.ACTUAL_AMOUNT;
          this.purchase_retrun.purchase_id = item.PURCHASE_ID
        }
      } else {
        this.purchase_retrun.uom_arr_name[i] = ''
        this.purchase_retrun.purchase_details_id[i] = ''
        this.purchase_retrun.uom_arr[i] = ''
        this.purchase_retrun.uom_arr_name[i] = ''
        this.purchase_retrun.paking_arr[i] = ''
        this.purchase_retrun.amount_arr[i] = ''
        this.purchase_retrun.unitprice_arr[i] = ''
        this.purchase_retrun.purchased_qty[i] = ''
        this.purchase_retrun.freebie_qty[i] = ''
        this.purchase_retrun.vat_arr[i] = ''
        this.purchase_retrun.gross_arr[i] = ''
        this.purchase_retrun.actual_arr[i] = ''
        this.purchase_retrun.purchase_id = ''
      }
    });
  }

  public totalAmount() {
    let sum = 0;
    this.purchase_retrun.amount_arr.forEach((item: any, index: any) => {
      const amount = parseFloat(this.purchase_retrun.return_amount_arr[index]);

      if (!isNaN(amount)) {
        sum = sum + amount;
      }
    });
    this.total_amount = sum;
  }

  public set_item_medicine($event: any, i: any) {
    const item = $event.item;
    this.purchase_retrun.medicine_id_arr[i] = item.MEDICINE_ID;

  }

  getVendor() {
    this.purchase_retrun = {
      vendor_id: '',
      puchase_id: '',
      invoice_date: '',
      customer_trn: '',
      return_reason: [""],
      sor_no: "",
      customer_ref: "",
      sales_person: "",
      return_date: new Date(),
      reference_no: "",
      purchase_id: 0,
      puchase_return_id: 0,
      medicine_data: [],
      medicine_id_arr: [""],
      purchase_details_id: [""],
      quantity_arr: [""],
      ava_quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      paking_arr: [""],
      amount_arr: [""],
      return_qty_arr: [""],
      unitprice_arr: [""],
      return_amount_arr: [""],
      purchased_qty: [""],
      freebie_qty: [""],
      actual_arr: [""],
      vat_arr: [""],
      gross_arr: [""],
      user_id: '',
      invoice_no: [""]

    }
    this.invoice_data = '';
    this.purchase_retrun.vendor_id = this.vendor_data.VENDOR_ID;
  }

  public addrow(index: any) {
    this.purchase_details[index + 1] = '';
    this.purchase_retrun.medicine_data[index + 1] = '';
    this.purchase_retrun.purchase_details_id[index + 1] = '';
    this.purchase_retrun.quantity_arr[index + 1] = '';
    this.purchase_retrun.ava_quantity_arr[index + 1] = '';
    this.purchase_retrun.uom_arr_name[index + 1] = '';
    this.purchase_retrun.return_amount_arr[index + 1] = '';
    this.purchase_retrun.return_qty_arr[index + 1] = '';
    this.purchase_retrun.amount_arr[index + 1] = '';
    this.purchase_retrun.paking_arr[index + 1] = '';
    this.purchase_retrun.unitprice_arr[index + 1] = '';
    this.purchase_retrun.purchased_qty[index + 1] = '';
    this.purchase_retrun.freebie_qty[index + 1] = '';
    this.purchase_retrun.vat_arr[index + 1] = '';
    this.purchase_retrun.gross_arr[index + 1] = '';
    this.purchase_retrun.actual_arr[index + 1] = '';
    this.purchase_retrun.invoice_no[index + 1] = '';
  }

  public deleterow(index: any) {
    this.purchase_details.splice(index, 1);
    this.purchase_retrun.medicine_data.splice(index, 1);
    this.purchase_retrun.medicine_id_arr.splice(index, 1);
    this.purchase_retrun.quantity_arr.splice(index, 1);
    this.purchase_retrun.ava_quantity_arr.splice(index, 1);
    this.purchase_retrun.uom_arr_name.splice(index, 1);
    this.purchase_retrun.purchase_details_id.splice(index, 1);
    this.purchase_retrun.amount_arr.splice(index, 1);
    this.purchase_retrun.return_amount_arr.splice(index, 1);
    this.purchase_retrun.paking_arr.splice(index, 1);
    this.purchase_retrun.return_qty_arr.splice(index, 1);
    this.purchase_retrun.unitprice_arr.splice(index, 1);
    this.purchase_retrun.purchased_qty.splice(index, 1);
    this.purchase_retrun.freebie_qty.splice(index, 1);
    this.purchase_retrun.vat_arr.splice(index, 1);
    this.purchase_retrun.gross_arr.splice(index, 1);
    this.purchase_retrun.actual_arr.splice(index, 1);
    this.purchase_retrun.invoice_no.splice(index, 1);
    this.totalAmount();
  }

  public getDropdowns() {
    const postData = {
      vendor_id: ''
    }
    this.loaderService.display(true);
    this.rest2.listPurchaseVendor(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.vendor = result['data'];
        this.vendor_options = this.vendor;
        for (let index = 0; index < this.vendor_options.length; index++) {
          if (this.vendor_options[index].VENDOR_ID == this.purchase_retrun.vendor_id) {
            this.vendor_data = this.vendor_options[index];
          }
        }
      }
    });
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public invoiceDate(): string {
    return this.date;
  }

  public saveReturnPurchase(): any {
    let rel = 1;

    if (this.purchase_retrun.vendor_id == '' || this.purchase_retrun.vendor_id == 0) {
      this.toast.error('Please select a Vendor !');
      return false
    }

    if (this.purchase_retrun.return_date == '') {
      this.toast.error('Please select Return date !');
      return false
    }
    this.purchase_retrun.quantity_arr.forEach((item: any, index: any): any => {
      if (this.purchase_retrun.return_qty_arr[index] == "") {
        this.toast.error('Enter Return quantity');
        rel = 0;
        return false;
      }
      if (parseInt(this.purchase_retrun.quantity_arr[index]) < parseInt(this.purchase_retrun.return_qty_arr[index])) {
        this.toast.error('Invalid Return quantity');
        rel = 0;
        return false;
      }
      if (parseInt(this.purchase_retrun.ava_quantity_arr[index]) < parseInt(this.purchase_retrun.return_qty_arr[index])) {
        this.toast.error('Invalid Return quantity');
        rel = 0;
        return false;
      }
      if (parseInt(this.purchase_retrun.gross_arr[index]) < parseInt(this.purchase_retrun.return_amount_arr[index])) {
        this.toast.error('Invalid Return amount');
        rel = 0;
        return false;
      }
      if (this.purchase_retrun.return_reason[index] == "") {
        this.toast.error('Enter return reason');
        rel = 0;
        return false;
      }
    });
    if (rel == 0) {
      return false
    }
    this.purchase_retrun.user_id = this.user_data.user_id
    this.loaderService.display(true);
    this.rest2.saveReturnPurchase(this.purchase_retrun).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toast.success(result.msg);
        this.purchase_retrun.puchase_return_id = result.data_id;
        this.clear_purchase();
      } else {
        this.toast.error(result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public clear_purchase() {
    this.purchase_details = ["0"];
    this.total_amount = 0;
    this.purchase_retrun = {
      vendor_id: '',
      invoice_date: '',
      purchase_id: 0,
      puchase_return_id: 0,
      medicine_data: [],
      medicine_id_arr: [""],
      quantity_arr: [""],
      ava_quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      paking_arr: [""],
      purchase_details_id: [""],
      amount_arr: [""],
      return_amount_arr: [""],
      return_qty_arr: [""],
      unitprice_arr: [""],
      user_id: '',
      invoice_no: [""],
      purchased_qty: [""],
      freebie_qty: [""],
      actual_arr: [""],
      vat_arr: [""],
      gross_arr: [""],
    }
  }

  public returnValue() {
    let sum = 0;
    this.purchase_retrun.return_qty_arr.forEach((item: any, index: any): any => {
      const quantity = parseInt(this.purchase_retrun.return_qty_arr[index]);
      const actual = parseFloat(this.purchase_retrun.actual_arr[index]);
      if (!isNaN(quantity)) {
        sum = quantity * actual;
        this.purchase_retrun.return_amount_arr[index] = sum;
      }
      if (parseInt(this.purchase_retrun.quantity_arr[index]) < parseInt(this.purchase_retrun.return_qty_arr[index])) {
        this.toast.error('Invalid Return quantity');
        return false;
      }
      if (parseInt(this.purchase_retrun.ava_quantity_arr[index]) < parseInt(this.purchase_retrun.return_qty_arr[index])) {
        this.toast.error('Invalid Return quantity');
        return false;
      }
      if (parseInt(this.purchase_retrun.amount_arr[index]) < parseInt(this.purchase_retrun.return_amount_arr[index])) {
        this.toast.error('Invalid Return amount');
        return false;
      }

    });

  }

  public pushReason(i: any) {
    this.index = i
  }

  medicine_search = (text$: Observable<string>) =>

    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true,),
      switchMap(term =>
        this.rest2.medicine_purchase_search(term, this.purchase_retrun.vendor_id).pipe(
          map((response: any) => {
            this.searchFailed = false
            if (response.status == 'Success') {
              return response.data;
            } else {
              return [];
            }
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([])
          })
        )
      ),
      tap(() => this.searching = false)
    )

  formatter = (x: any): any => x.TRADE_NAME;

  protected open(content: any) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',}).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}

